import {
  Create,
  SimpleForm,
  TextInput,
  ArrayInput,
  SimpleFormIterator,
  ReferenceInput,
  SelectInput,
  BooleanInput,
  useNotify,
  useRedirect,
} from "react-admin";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import NoArrowKeyNumberInput from "@/components/NoArrowKeyNumberInput";
import { GoogleCalendarColorInput } from "@/components/GoogleCalendarColorInput";

export const BookingPurposeCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  return (
    <Create
      transform={(data: Record<string, unknown>) => {
        const { id: rawId, calendarColorId: rawColor, ...rest } = data;
        const id = typeof rawId === "string" ? rawId.trim() : "";
        const name = typeof rest.name === "string" ? rest.name.trim() : "";
        const calendarColorId =
          typeof rawColor === "string" && rawColor.trim() !== "" ? rawColor.trim() : null;
        return {
          ...rest,
          name,
          calendarColorId,
          ...(id ? { id } : {}),
        };
      }}
      mutationOptions={{
        onSuccess: (data) => {
          notify("Booking purpose created successfully");
          redirect("show", "bookingPurpose", data.id);
        },
      }}
    >
      <SimpleForm>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Name is required. Purpose ID is optional and must be unique if set.
        </Typography>
        <TextInput source="name" label="Name" required fullWidth />
        <TextInput
          source="id"
          label="Purpose ID (optional)"
          fullWidth
          helperText="Leave blank to derive from the name"
        />
        <GoogleCalendarColorInput
          source="calendarColorId"
          label="Google Calendar color"
          helperText="Used when raza-backed events with this purpose sync to Google Calendar. Ohbat events keep their own color."
        />
        <ArrayInput source="hallCharges" label="Hall Charges">
          <SimpleFormIterator>
            <Grid container spacing={2}>
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                  md: 10,
                }}
              >
                <ReferenceInput source="hallId" reference="halls" label="Hall" required>
                  <SelectInput optionText={(record) => `${record.name} (${record.shortCode})`} />
                </ReferenceInput>
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                  md: 3,
                }}
              >
                <NoArrowKeyNumberInput source="rent" label="Rent (₹)" defaultValue={0} />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                  md: 3,
                }}
              >
                <NoArrowKeyNumberInput source="deposit" label="Deposit (₹)" defaultValue={0} />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                  md: 2,
                }}
              >
                <NoArrowKeyNumberInput source="acCharges" label="AC Charges (₹)" defaultValue={0} />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                  md: 2,
                }}
              >
                <NoArrowKeyNumberInput
                  source="kitchenCleaning"
                  label="Kitchen Cleaning (₹)"
                  defaultValue={0}
                />
              </Grid>
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                  md: 2,
                }}
              >
                <BooleanInput source="includeThaalCharges" label="Include Thaal Charges" />
              </Grid>
            </Grid>
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Create>
  );
};

export default BookingPurposeCreate;
